<template>
  <div class="" style="height: 400px; margin-top: -738px"
       :style="myStyle">
    <v-container>
      <v-card
        width="320"
        class="transparent"
        elevation="0"
        style="padding-top: 70px !important"
      >
        <h1 class="">
          <span class="mx-auto text-center text-header white--text text-left"
            >{{title}} <strong>{{boldTitle}}</strong></span
          >
        </h1>
      </v-card>

      <v-card-text
        style="width: 400px; font-size: 20px !important"
        class="mt-12 white--text text-subtitle-1 text-sub-header margin-line font-weight-regular mx-n4"
      >
        {{description}}
      </v-card-text>
    </v-container>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type: String,
      required: true,
    },
    boldTitle:{
      type: String,
      required: true,
    },
    description:{
      type: String,
      required: true,
    },
    myStyle:{
      type: String,
      required: true,
    }
  },
  name: "ComponentBannerService",
};
</script>

<style scoped>
strong {
  color: white;
  text-shadow: 1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue;
}
.text-header {
  font-family: "Fira Sans Condensed", sans-serif;
  line-height: 42px;
  font-size: 38px;
  font-weight: 500;
}

:root {
  --text-color: #616266;
  --header: #32363b;
  --background: #32363b;
}

.bg-header-inst {
  background-image: linear-gradient(
      295deg,
      rgba(15, 15, 16, 0.68),
      rgb(0, 0, 0)
    ),
    url("https://img.freepik.com/free-vector/3d-earth-graphic-symbolizing-global-trade-illustration_456031-131.jpg");
  background-size: cover;
  background-color: #efefef;
}
</style>
